import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useState } from "react";
import DatePicker from "react-datepicker";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Trans, useTranslation } from "react-i18next";
import SelectElement from "../components/event-selection/selectElement";
import TextArea from "../components/event-selection/textArea";
import { postEpidemic } from "../services/epidemicService";
import Loaing from "../icons/loaing";
import ConfirmModal from "../components/ConfirmModal";
import postEvent from "../services/eventService";
import FormBorder from "../components/formBorder";
import TextareaAndQmark from "../components/event-selection/Textare&Qmark";
import { PDFDownloadLink } from "@react-pdf/renderer";
import moment from "moment";
import { EpidemicPdf } from "../components/dashboard/epidemic-pdf";
import CalendarIcon from "../icons/calendar";
export type EpidemicTypes = {
  eventDate: string;
  reporting: string;
  illness: string;
  numberOfChildren: number;
  numberOfTeacher: number;
  actionTaken: string;
  printeventDate?: boolean;
  printillness?: boolean;
  printnumberOfChildren?: boolean;
  printnumberOfTeacher?: boolean;
  printactionTaken?: boolean;
};

const schema = yup.object({
  eventDate: yup.date().required(),
  illness: yup.string().required(),
  numberOfChildren: yup.string().required(),
  numberOfTeacher: yup.string().required(),
  actionTaken: yup.string().required(),
});

const Epidemic = () => {
  const [confirmModalVisible, setConfirmModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState<null | Date>(null);
  const [pdfData, setPdfData] = useState<any>(undefined);

  const { t } = useTranslation();

  const handleDownload: SubmitHandler<EpidemicTypes> = async (data) => {
    data.eventDate = moment(startDate).format("YYYY-MM-DD");
    setPdfData(data);
  };

  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm<EpidemicTypes>({ resolver: yupResolver(schema) });

  const onSubmit: SubmitHandler<EpidemicTypes> = async (data) => {
    setLoading(true);
    try {
      const {
        printactionTaken,
        printillness,
        printnumberOfChildren,
        printnumberOfTeacher,
        printeventDate,
        ...rest
      } = data;
      rest.eventDate = moment(startDate).format("YYYY-MM-DD");
      const response = await postEpidemic({ ...rest });

      if (response.message === "created") {
        // TODO: needs test
        const eventpost = await postEvent({
          eventId: response.data._id,
          eventDetailsDate: response.data?.eventDate,
        });
        if ((eventpost.message = "created")) {
          toast.success("epidemic event created succesfully!");
          setLoading(false);
          navigate("/confirm");
        }
      }
    } catch (error: any) {
      setLoading(false);
      toast.error(error);
    }
  };
  const resetForm = () => {
    setConfirmModalVisible(false);
    setPdfData(null);
    reset();
  };

  return (
    <section className="relative font-Poppins px-[20px] lg:px-0">
      <div>
        <div className="grid gap-3 lg:mx-10">
          <div className="w-16 h-16">
            <img
              src="/images/report.png"
              alt="!"
              className="max-w-full h-auto"
            />
          </div>
          <h1 className="text-4xl font-bold">
            <Trans i18nKey="Epidemic">Epidemic</Trans>
          </h1>
          <p className="text-xl text-[#6B6B6B]">
            <Trans i18nKey="Epidemic_form_message">
              Please note here illness / disease contagious which presented
              itself in at least 4 members of the nursery (children / staff)
              within 10 working days, and had presented a high likelihood of
              infecting other staff and children at the nursery
            </Trans>
          </p>
        </div>
      </div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex justify-end gap-[15px] lg:px-[20px] my-5 lg:my-10">
          <button
            type="button"
            className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
            onClick={() => setConfirmModalVisible(true)}
          >
            <Trans t={t}>Reset</Trans>
          </button>
          {pdfData ? (
            <PDFDownloadLink
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              document={<EpidemicPdf formData={pdfData} />}
              fileName={"epidemic.pdf"}
            >
              {({ blob, url, loading, error }) =>
                loading ? "Loading..." : "Download PDF"
              }
            </PDFDownloadLink>
          ) : (
            <button
              className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
              onClick={handleSubmit(handleDownload)}
            >
              <Trans>Generate PDF</Trans>
            </button>
          )}
        </div>

        <FormBorder>
          <div className="grid gap-5">
            <div className="grid md:grid-cols-2 grid-cols-1 w-full gap-[5px] md:gap-0 ">
              <label
                htmlFor="eventDate"
                className="font-normal text-xl text-[#1E408E]"
              >
                <Trans t={t}>Event Date</Trans>
              </label>
              <div className=" pr-10">
                <div className="flex flex-row">
                  <div className="mr-4 bg-white w-full flex items-center border border-[#8692A6] h-12 p-2 rounded">
                    <Controller
                      control={control}
                      {...register(`eventDate`)}
                      name="eventDate"
                      render={({ field }) => (
                        <DatePicker
                          filterDate={(d) => {
                            return new Date() > d;
                          }}
                          selectsRange={false}
                          onChange={(date: Date) => {
                            field.onChange(date?.toDateString());
                            setStartDate(date);
                          }}
                          placeholderText="mm/dd/yyyy"
                          selected={startDate}
                          dateFormat={"dd MMM yyyy"}
                          isClearable={false}
                          className="w-full border-none p-0 bg-white focus:outline-none"
                        />
                      )}
                    />
                    <CalendarIcon />
                  </div>
                  <input
                    type="checkbox"
                    {...register("printeventDate")}
                    defaultChecked
                    id={"printeventDate"}
                  />
                </div>
                {errors["eventDate"] && (
                  <p className="text-red-500 mt-2 text-sm">
                    {errors["eventDate"]?.message}
                  </p>
                )}
              </div>
            </div>
            <SelectElement
              register={register}
              errors={errors}
              name="illness"
              printEnabled
              label="Illness/Infections"
              options={[
                "Bronchitis",
                "Conjonctivitis",
                "Covid-19",
                "Flo/Cold",
                "Gastroenteritis",
                "Hand Foot and Mouth",
                "Hepatitis A",
                "Viral infection",
                "Tinea Corporis",
                "Varicella",
                "Other",
              ]}
              translateId="illness"
            />
            <TextareaAndQmark
              register={register}
              printEnabled
              errors={errors}
              name="numberOfChildren"
              label="Number of Children"
              translateId="numberOfChildren"
              i18nKey="Help Box - Epidemic - Number of children infected"
            />
            <TextareaAndQmark
              printEnabled
              register={register}
              errors={errors}
              name="numberOfTeacher"
              label="Number of Teacher/Adult infected"
              translateId="Number of Teacher or Adult infected"
              i18nKey="Help Box - Epidemic - Number of teacher/adult infected"
            />

            <TextArea
              register={register}
              errors={errors}
              name="actionTaken"
              label="Actions Taken"
              translateId="actionTaken"
              printEnabled
            />
          </div>
        </FormBorder>
        <div className="flex justify-end lg:px-[20px] mt-10">
          <button
            type={"submit"}
            className="px-5 py-2 rounded-full text-white bg-[#1E408E]"
          >
            <Trans i18nKey="Submit">Submit</Trans>
          </button>
          {loading && <Loaing />}
        </div>
      </form>
      <ConfirmModal
        isOpen={confirmModalVisible}
        setIsOpen={setConfirmModalVisible}
        onConfirm={resetForm}
      />
    </section>
  );
};

export default Epidemic;
